import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import NoGapContentpoints from "../../Components/sub-pages/NoGapContent_point";

const BrandStore =()=>{
    const CTAContent = [
        {
          pageName: "Brand-store",
          paragraphitalic: "Your Brand, One Click Away ",
          paragraphText:
                "Bring your brand to life with a fully customized online store that showcases your company’s identity. Our Brand Stores are tailored to reflect your unique style and offer your employees and partners easy access to high-quality branded merchandise.",
          ContactFormName: "Brand-Store",
        },
      ];
    
      const ListContent=[
        {
            Heading:[
                {
                    ListHeading:"Custom-Branded Apparel & Accessories ",
                },
                {
                    ListHeading:"Event-Specific Merchandise",
                },
                {
                    ListHeading:"Eco-Friendly & Premium Gift Options",
                }
            ],
            RightImgNogap:"../assests/images/company-store/Brand store_inside.png"
        }
      ]
      
    
  return (
    <>
      <Helmet>
        <title>eYantra Company Store & Gifting Solutions</title>
        <meta name="description" content="eYantra’s company store offers office supplies, employee gifts, joining kits, branded merchandise, and personalised business items for corporate gifting."/>
        <meta name="keywords" content="eyantra, company store, office supplies,branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits, employee gifts, personalised business items "/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <NoGapContentpoints data={ListContent[0]}/>
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        From sleek designs to seamless navigation, our Brand Stores are designed to develop your brand’s visibility and create memorable shopping experiences for everyone involved.
      </p>
    </>
  );
};

export default BrandStore;